import Vue from 'vue';
import VueRouter from 'vue-router'
import Meta from 'vue-meta'

import Index from "../../components/Index"
import NotFound from "../../components/NotFound"
import Login from "../../components/Auth/Login"
import Dashboard from "../../components/Dashboard/Index"
import Reports from "../../components/Dashboard/Reports/Collection"
import Statistics from "../../components/Dashboard/Statistics/Index"

Vue.use(VueRouter)
Vue.use(Meta)

const routes = [
  {
    name: 'index',
    path: '/',
    component: Index,
  },

  {
    name: 'login',
    path: '/inlogg/:company',
    component: Login,
    meta: {
      guest: true
    },
  },

  {
    name: 'dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: {
      auth: true
    },
    children: [
      {
        name: 'statistics',
        path: 'statistics',
        component: Statistics,
        meta: {
          auth: true
        },
      },
      {
        name: 'reports',
        path: 'spreadsheets',
        component: Reports,
        meta: {
          auth: true
        },
      },
    ]
  },

  {
    name: 'notfound',
    path: '*',
    component: NotFound,
    meta: {
      guest: true
    },
  },
];

const authFromStore = (store) => {
  return null !== store.state.auth.company.handle
}

const authByToken = async (store) => {
  const token = window.$cookies.get('authToken')

  if (token) {
    await store.dispatch('loginWithToken', {token})

    return authFromStore(store)
  }

  return false
}

export function createRouter (store) {

  let router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
      /**
       * If there is saved position - display it
       */
      if (savedPosition) {
        return savedPosition;

        /**
         * Otherwise check if to-route has custom scroll-saving enabled. If no - scroll to beginning, if yes - do not
         * do anything, and the route will be loaded with the scroll position of previous one
         */
      } else if (to.meta.saveScroll !== true) {
        return {x: 0, y: 0};
      }
    }
  });

  router.beforeEach(async (to, from, next) => {

    if(to.meta.guest === true){
      //todo - remove auth
      return next();
    } else if(to.meta.auth === true){

      if(authFromStore(store) || await authByToken(store)){
        return next();
      }

      return next('/');
    }

    return next();
  });

  return router;

}



// WEBPACK FOOTER //
// ./resources/assets/js/app/router/index.js